module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Italic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Italic-webfont.ttf
// module id = 359
// module chunks = 0